import Base64Manager from "./Base64Manager";

import {fabric} from "fabric";

class CanvasManager {
    listener = false;

    constructor() {
    }

    async init(jobStage) {
        let canvasExists = false;
        if (jobStage.canvas.canvas !== null) {
            canvasExists = true;
        }

        this.initMainCanvas(jobStage, canvasExists);
        this.initPreviewCanvas(jobStage, canvasExists);
        this.initExportCanvas(jobStage);
    }

    async initMainCanvas(jobStage, canvasExists) {
        let base64Image = await Base64Manager.getImage(jobStage.mainJob.apiJob.output[0].uri);
        let evtJobStage = jobStage;



        jobStage.canvas.canvas = new fabric.Canvas(jobStage.canvas.container, {
            backgroundImage: base64Image,
            isDrawingMode: true,
            //width: jobStage.mainJob.apiJob.output[0].metadata.image_width,
            //height: jobStage.mainJob.apiJob.output[0].metadata.image_height
        });

        var clipPath = new fabric.Rect({
            width: jobStage.mainJob.apiJob.output[0].metadata.image_width,
            height: jobStage.mainJob.apiJob.output[0].metadata.image_height,
            top: 0,
            left: 0
        });
        jobStage.canvas.canvas.clipPath = clipPath;

        window.addEventListener('resize', resizeMainCanvas);

        function resizeMainCanvas() {
            jobStage.canvas.canvas.setHeight(document.getElementById("magic-stage").offsetHeight);
            jobStage.canvas.canvas.setWidth(document.getElementById("magic-stage").offsetWidth);
            jobStage.canvas.canvas.renderAll.bind(jobStage.canvas.canvas);
        }

        resizeMainCanvas();

        jobStage.canvas.canvas.on('mouse:wheel', function (opt) {
            var delta = opt.e.deltaY;
            var zoom = jobStage.canvas.canvas.getZoom();
            zoom *= 0.999 ** delta;
            if (zoom > 20) zoom = 20;
            if (zoom < 0.01) zoom = 0.01;
            jobStage.canvas.canvas.zoomToPoint({x: opt.e.offsetX, y: opt.e.offsetY}, zoom);
            opt.e.preventDefault();
            opt.e.stopPropagation();
        });

        jobStage.canvas.canvas.setBackgroundImage(base64Image, (evt) => {

            //resizeMainCanvas();
            this.zoomFitAllObjects(jobStage);

            if (canvasExists === true) {
                jobStage.canvas.jsonLoading = false;
                let jsonIndex = jobStage.canvas.history.length-1;
                let json = jobStage.canvas.history[jsonIndex];

                this.load(jobStage, json);
            } else {
                this.addHistory(evtJobStage);
                jobStage.canvas.historyIndex = 0;
            }
        })


        jobStage.canvas.canvas.on('object:modified', (evt) => {
        });
        jobStage.canvas.canvas.on('object:added', (evt) => {
            this.addHistory(evtJobStage);

            if (jobStage.canvas.jsonLoading === false) {
                this.updateMask(jobStage);
            }
        });


        await this.setToolFreeDrawingBrush(jobStage);
    }

    async initPreviewCanvas(jobStage, canvasExists) {
        let base64Image = await Base64Manager.getImage(jobStage.mainJob.apiJob.output[0].uri);

        jobStage.previewCanvas.canvas = new fabric.Canvas(`${jobStage.canvas.container}-preview`, {
            backgroundImage: base64Image,
            skipTargetFind: true,
            selection: false,
            width: jobStage.mainJob.apiJob.output[0].metadata.image_width,
            height: jobStage.mainJob.apiJob.output[0].metadata.image_height
        });

        window.addEventListener('resize', resizePreviewCanvas);

        function resizePreviewCanvas() {
            jobStage.previewCanvas.canvas.setHeight(document.getElementById("magic-stage").offsetHeight);
            jobStage.previewCanvas.canvas.setWidth(document.getElementById("magic-stage").offsetWidth);
            jobStage.previewCanvas.canvas.renderAll.bind(jobStage.previewCanvas.canvas)
        }

        resizePreviewCanvas();

        jobStage.previewCanvas.canvas.on('mouse:wheel', function (opt) {
            var delta = opt.e.deltaY;
            var zoom = jobStage.previewCanvas.canvas.getZoom();
            zoom *= 0.999 ** delta;
            if (zoom > 20) zoom = 20;
            if (zoom < 0.01) zoom = 0.01;
            jobStage.previewCanvas.canvas.zoomToPoint({x: opt.e.offsetX, y: opt.e.offsetY}, zoom);
            opt.e.preventDefault();
            opt.e.stopPropagation();
        });

        if (canvasExists === true) {
            let json = jobStage.canvas.canvasJsonPreview;

            this.loadPreview(jobStage, json);
        }
    }

    async initExportCanvas(jobStage) {
        let base64Image = await Base64Manager.getImage(jobStage.mainJob.apiJob.output[0].uri);

        jobStage.exportCanvas.canvas = new fabric.Canvas(`${jobStage.canvas.container}-export`, {
            backgroundImage: base64Image,
            isDrawingMode: false,
            width: jobStage.mainJob.apiJob.output[0].metadata.image_width,
            height: jobStage.mainJob.apiJob.output[0].metadata.image_height
        });

    }

    async zoomIn(jobStage) {
        let canvas = null;
        if (jobStage.preview === true) {
            canvas = jobStage.previewCanvas.canvas;
        } else {
            canvas = jobStage.canvas.canvas;
        }

        let zoom = canvas.getZoom();
        zoom = zoom +.1;
        if (zoom > 20) zoom = 20;
        if (zoom < 0.01) zoom = 0.01;

        canvas.zoomToPoint(new fabric.Point(canvas.width / 2, canvas.height / 2), zoom);
    }

    async zoomOut(jobStage) {
        let canvas = null;
        if (jobStage.preview === true) {
            canvas = jobStage.previewCanvas.canvas;
        } else {
            canvas = jobStage.canvas.canvas;
        }

        let zoom = canvas.getZoom();
        zoom = zoom -.1;
        if (zoom > 20) zoom = 20;
        if (zoom < 0.01) zoom = 0.01;

        canvas.zoomToPoint(new fabric.Point(canvas.width / 2, canvas.height / 2), zoom);
    }

    async zoomFitAllObjects(jobStage) {
        let canvas = null;
        if (jobStage.preview === true) {
            canvas = jobStage.previewCanvas.canvas;
        } else {
            canvas = jobStage.canvas.canvas;
        }

        let stageRect = new fabric.Rect({
            width: jobStage.mainJob.apiJob.output[0].metadata.image_width,
            height: jobStage.mainJob.apiJob.output[0].metadata.image_height,
            top: 0,
            left: 0
        });

        canvas.setZoom(1);
        const group = new fabric.Group([stageRect]);
        const x = (group.left + (group.width / 2)) - (canvas.width / 2);
        const y = (group.top + (group.height / 2)) - (canvas.height / 2);
        canvas.absolutePan({x: x, y: y});
        const heightDist = canvas.getHeight() - group.height;
        const widthDist = canvas.getWidth() - group.width;
        let groupDimension = 0;
        let canvasDimension = 0;


        if (heightDist < widthDist) {
            groupDimension = group.height;
            canvasDimension = canvas.getHeight();
        } else {
            groupDimension = group.width;
            canvasDimension = canvas.getWidth();
        }
        const zoom = (canvasDimension / groupDimension) * 0.8;
        canvas.zoomToPoint({x: canvas.width / 2, y: canvas.height / 2}, zoom);

        canvas.renderAll.bind(canvas);

    }

    async setPreviewOriginal(jobStage) {
        jobStage.preview = true;
        await this.loadPreview(jobStage, jobStage.canvas.canvasJson);
    }

    async setDrawable(jobStage, drawable = true) {
        jobStage.canvas.canvas.isDrawingMode = drawable;
    }

    async undo(jobStage) {
        if (jobStage.canvas.jsonLoading === true) {
            return;
        }
        if (jobStage.canvas.historyIndex <= 0) {
            return;
        }

        jobStage.canvas.historyIndex--;
        let historyCanvas = jobStage.canvas.history[jobStage.canvas.historyIndex];

        this.load(jobStage, historyCanvas);
    }

    async redo(jobStage) {
        if (jobStage.canvas.jsonLoading === true) {
            return;
        }
        let maxIndex = jobStage.canvas.history.length - 1;
        if (jobStage.canvas.historyIndex >= maxIndex) {
            return;
        }
        jobStage.canvas.historyIndex++;
        let historyCanvas = jobStage.canvas.history[jobStage.canvas.historyIndex];
        this.load(jobStage, historyCanvas);
    }

    async load(jobStage, json) {
        if (jobStage.canvas.jsonLoading === true) {
            return;
        }
        jobStage.canvas.jsonLoading = true;

        jobStage.canvas.canvas.loadFromJSON(json, () => {

            jobStage.canvas.canvas.renderAll.bind(jobStage.canvas.canvas)
            jobStage.canvas.jsonLoading = false;
            this.updateMask(jobStage);
        });
    }

    async loadPreview(jobStage, json) {
        jobStage.canvas.canvasJsonPreview = json;
        jobStage.previewCanvas.canvas.loadFromJSON(json, () => {
            jobStage.canvas.canvas.renderAll.bind(jobStage.canvas.canvas);
            this.zoomFitAllObjects(jobStage);
        });
    }

    async addHistory(jobStage) {
        if (jobStage.canvas.jsonLoading === true) {
            return;
        }

        jobStage.canvas.historyIndex++;
        jobStage.canvas.canvasJson = jobStage.canvas.canvas.toJSON();

        if (jobStage.canvas.history.length > jobStage.canvas.historyIndex) {
            jobStage.canvas.history = jobStage.canvas.history.slice(0, jobStage.canvas.historyIndex);
        }

        jobStage.canvas.history.push(jobStage.canvas.canvasJson);
    }

    async setToolFreeDrawingBrush(jobStage) {
        jobStage.canvas.activeTool = 'freeDrawingBrush';
        jobStage.canvas.canvas.freeDrawingBrush.width = jobStage.canvas.settings.freeDrawingBrush.width;
        jobStage.canvas.canvas.freeDrawingBrush.color = 'rgba(18, 102, 241, 0.8)';
    }

    async updateMask(jobStage) {
        let canvasJson = jobStage.canvas.canvas.toJSON();

        jobStage.exportCanvas.canvas.loadFromJSON(canvasJson, () => {
            jobStage.exportCanvas.canvas.setBackgroundImage(null);

            //let image = await encodeImageToBase64(blob);
            jobStage.canvas.mask = jobStage.exportCanvas.canvas.toDataURL({
                width: jobStage.exportCanvas.canvas.width,
                height: jobStage.exportCanvas.canvas.height,
                left: 0,
                top: 0,
                format: 'png',
            });
        });


    }

    async restoreCanvas(jobStage) {
        jobStage.canvas.canvas.loadFromJSON(jobStage.canvas.canvasJson, jobStage.canvas.canvas.renderAll.bind(jobStage.canvas.canvas));
    }

    clearMask(jobStage) {
        jobStage.canvas.canvas.clear();
    }

    async setPreview(jobStage, url) {
        let image = await Base64Manager.getImage(url);
        jobStage.previewCanvas.canvas.clear();
        jobStage.previewCanvas.canvas.setBackgroundImage(image, jobStage.previewCanvas.canvas.renderAll.bind(jobStage.previewCanvas.canvas));
    }
}

export default new CanvasManager();